import { render, staticRenderFns } from "./CardRelacion.vue?vue&type=template&id=187535e4&scoped=true"
import script from "./CardRelacion.vue?vue&type=script&lang=js"
export * from "./CardRelacion.vue?vue&type=script&lang=js"
import style0 from "./CardRelacion.vue?vue&type=style&index=0&id=187535e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187535e4",
  null
  
)

export default component.exports